import { monthNames } from '../constants/dateFormat.constants';

const padTo2Digits = (num: number) => num.toString().padStart(2, '0');

export const formatDate = (date: Date) =>
  [padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate()), date.getFullYear()].join('/');

export const formatDateWithMonth = (date: Date) =>
  `${monthNames[date.getUTCMonth()]} ${date.getUTCDate()}, ${date.getUTCFullYear()}`;
